<div class="ai-assistant-main">
  <div class="ai-assistant-title">
      <p class="vox-heading-2" translate>internal-facilities.ai-assistant.title</p>
  </div>
  <hr />
  <div class="ai-assistant-content">
    <button class="vox-btn vox-btn-secondary" (click)="addDictionary()"
    translate>internal-facilities.ai-assistant.add</button>
    <div class="vox-input-group vox-input-group_dense">
      <input class="vox-text-field" type="text" [(ngModel)]="searchKey"
      [ngModelOptions]="{standalone: true}"
      (keyup.enter)="searchDictionary()"
      [placeholder]="'internal-facilities.ai-assistant.search.placeholder' | translate"/>
      <i class="vox-text-field__icon icon-small-search" (click)="searchDictionary()"></i>
    </div>
    <gdp-ai-assistant-table [dictionary]="dictionary" [loading]="loading"
    (onUpdatingDictionary)="updateDictionary($event)"
    (onDeletingDictionary)="deleteDictionary()"></gdp-ai-assistant-table>
    <gdp-table-pagination (onSelectPageSize)="selectPageSize($event)"
    (onChangeCurrentPage)="changeCurrentPage($event)" [totalPages]="pagination.totalPages"
    [pagination]="pagination" [selectedPageSize]="pageSize"></gdp-table-pagination>
  </div>
</div>